import { computed } from 'vue'
import { defineStore } from 'pinia'
import { useSet } from '../useSet'
import { usePredicates } from '@/ContextTab/stores/newsSet/usePredicates'
import { useUserProfileStore } from '@/ContextTab/stores/userProfile'


export const useWaitingNewsStore = defineStore('waitingNews', () => {

  const { taskPanelPredicates } = usePredicates()

  const userProfileStore = useUserProfileStore()

  const setParams = computed(() => ({
    group_ids: userProfileStore.profile.filters?.news_waiting?.groups?.ids?.join(','),
    user_ids: userProfileStore.profile.filters?.news_waiting?.users?.ids?.join(','),
  }))

  return useSet({
    setType: 'waiting',
    predicates: taskPanelPredicates.waiting,
    setParams,
  })
})
